<li
		(mouseenter)="open()"
		(mouseleave)="close()"
		[class.active]="isActive()"
>
	@if (item.url) {
		<a
				#anchor
				bas-anchor-status
				[parameters]="item.parameters"
				class="nav-item top"
				[routerLink]="item.url"
				[queryParams]="item.query"
				(click)="active()"
				(focus)="focus()"
				(blur)="blur()"
		>
			<span>{{ item.name || (item.nameKey | msgKey) }}</span>
		</a>
	} @else if (item.url$) {
		<a
				#anchor
				bas-anchor-status
				[parameters]="item.parameters"
				class="nav-item top"
				[href]="item.url$ | async"
				(click)="active()"
				(focus)="focus()"
				(blur)="blur()"
				data-skipbeforeunload="true"
		>
			<span>{{ item.name || (item.nameKey | msgKey) }}</span>
		</a>
	} @else {
		<a
				#anchor
				bas-anchor-status
				[parameters]="item.parameters"
				class="nav-item top"
				(focus)="focus()"
				(blur)="blur()"
				style="cursor: context-menu;"
		>
			<span style="border: none;">{{ item.name || (item.nameKey | msgKey) }}</span>
		</a>
	}

	@if (hasChildren()) {
		<ul [@openState]="state">
			@for (subItem of item.children; track subItem.id) {
				<bas-nav-sub-item-level-1
						[item]="subItem"
						(itemClick)="close()"
				></bas-nav-sub-item-level-1>
			}
		</ul>
	}
</li>
